import React from 'react'
import "./maintainence.css"
import { useThemeContext } from '../../../../Context/ThemeContext.js';
import { DARKCOLORS, LIGHTCOLORS } from '../../../../Utils/constants.js';
import { useTranslation } from 'react-i18next';
import { Box, Divider } from '@mui/material';

import Overview from '../../../../assets/Help/overview.webp'
import ServiceList from '../../../../assets/Help/serviceList.webp'
import ComplaintDetails from '../../../../assets/Help/complaintDetails.webp'
import ServiceReqeust from '../../../../assets/Help/serviceReqeust.webp'

const Maintainence = () => {
    const { mode } = useThemeContext();
    const { t } = useTranslation();

    const subtitletext = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;
    const headingcolor2 = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;

    return (
        <div className='taxes-container'>
            <div className='maintainece-sec'>
                <Box className="taxes-title-sec">
                    <h2 className='tax-title home-title'>{t('help.helpMaintenance')}</h2>
                    <p style={{color: subtitletext}} className='home-subtitle'>{t('help.helpMaintenanceSubTitle')}</p>
                </Box>
                <Box className="doc-manage-Inventory  sec-1 ">
                    <p className='home-keyFeature-text doc-inventory-text' style={{ marginTop: '50px' }}> {t('help.helpServiceRequest')}</p>
                    <Divider className='divider view-divider' style={{ marginTop: '20px', marginBottom: '50px' }} />
                    {/* 6.1 */}
                    <Box className='number-sec-container'>
                        <Box className="list-container manage-list-container">
                            <Box className='doc-inventory-title-sec'>
                                <p className='number-structure'> {t('help.Overview')}</p>
                            </Box>
                            <Box className='manage-discription level_2'>
                                <ul className='display-list' >
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.OverviewPoint1bold')}</span>  {t('help.OverviewPoint1text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.OverviewPoint2bold')}</span>  {t('help.OverviewPoint2text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disk'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.OverviewPoint3bold')} </span> 
                                     {t('help.OverviewPoint3text')}
                                    </li>
                                </ul>
                            </Box>
                        </Box>
                        <Box className='nav-svg-sec' >
                            <img style={{
                                backgroundColor: 'white', borderRadius: '5px',
                                width: '90%',
                            }} src={Overview} alt="Machine Card" />
                        </Box>
                    </Box>

                    <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />
                    {/* 6.2 */}
                    <Box className='number-sec-container'>
                        <Box className="list-container manage-list-container">
                            <Box className='doc-inventory-title-sec '>
                                <p className='number-structure'> {t('help.serviceList')}</p>
                            </Box>
                            <Box className='manage-discription level_2'>
                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'> {t('help.serviceListpoint1')}</p>
                                <ul className='display-list' >
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.serviceListPoint2bold')}</span> {t('help.serviceListPoint2text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.serviceListPoint3bold')}
                                     </span> {t('help.serviceListPoint3text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.serviceListPoint4bold')} </span>  {t('help.serviceListPoint4text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.serviceListPoint5bold')} </span>  {t('help.serviceListPoint5text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.serviceListPoint6bold')}  </span> {t('help.serviceListPoint6text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.serviceListPoint7bold')} </span>  {t('help.serviceListPoint7text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.serviceListPoint8bold')} </span> {t('help.serviceListPoint8text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.serviceListPoint9bold')}  </span> {t('help.serviceListPoint9text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.serviceListPoint10bold')} </span>{t('help.serviceListPoint10text')}
                                    </li>
                                </ul>
                            </Box>
                        </Box>
                        <Box className='nav-svg-sec' >
                            <img style={{
                                backgroundColor: 'white', borderRadius: '5px',
                                width: '90%',
                            }} src={ServiceList} alt="Machine Card" />

                        </Box>
                    </Box>
                    <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />
                    {/* 6.3 */}
                    <Box className='number-sec-container'>
                        <Box className="list-container manage-list-container">
                            <Box className='doc-inventory-title-sec '>
                                <p className='number-structure'> 
                                    {t('help.complaintDetails1')} {t('help.complaintDetails2')} </p>
                            </Box>
                            <Box className='manage-discription level_2'>
                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'>{t('help.complaintDetailspoint1')}</p>
                                <ul className='display-list' >
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.complaintDetailsPoint2bold')}</span> {t('help.complaintDetailsPoint2text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.complaintDetailsPoint3bold')}</span>    
                                    {t('help.complaintDetailsPoint3text')}
                                    <br/>{t('help.complaintDetailsPoint1subtext')}
                                    <br/>{t('help.complaintDetailsPoint2subtext')}
                                    <br/>{t('help.complaintDetailsPoint3subtext')}
                                    <br/>{t('help.complaintDetailsPoint4subtext')}
                                    <br/>{t('help.complaintDetailsPoint5subtext')}
                                    <br/>{t('help.complaintDetailsPoint6subtext')}
                                    <br/>{t('help.complaintDetailsPoint7subtext')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.complaintDetailsPoint8bold')}</span> {t('help.complaintDetailsPoint8text')}
                                    </li>
                                </ul>
                            </Box>
                        </Box>
                        <Box className='nav-svg-sec' >
                            <img style={{
                                backgroundColor: 'white',
                                borderRadius: '5px',
                                width: '100%',
                            }} src={ComplaintDetails} alt="Machine Card" />
                        </Box>
                    </Box>
                    <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />
                    {/* 6.4 */}
                    <Box sx={{marginBottom:'50px'}} className='number-sec-container'>
                        <Box className="list-container manage-list-container">
                            <Box className='doc-inventory-title-sec '>
                                <p className='number-structure'> {t('help.ServiceRequestForm1')}  {t('help.ServiceRequestForm2')}  </p>
                            </Box>
                            <Box className='manage-discription level_2'>
                                <p style={{
                                    color: subtitletext, marginTop: '10px'
                                }} className='home-Navi-bar-text'> {t('help.ServiceRequestFormpoint1')}</p>
                                <ul className='display-list' >

                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.ServiceRequestFormPoint2bold')}</span> {t('help.ServiceRequestFormPoint2text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.ServiceRequestFormPoint3bold')} </span>  {t('help.ServiceRequestFormPoint3text')}
                                    </li>
                                    
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.ServiceRequestFormPoint4bold')}</span>  {t('help.ServiceRequestFormPoint4text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.ServiceRequestFormPoint5bold')}</span>  {t('help.ServiceRequestFormPoint5text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.ServiceRequestFormPoint6bold')}</span> {t('help.ServiceRequestFormPoint6text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.ServiceRequestFormPoint7bold')}</span>  {t('help.ServiceRequestFormPoint7text')}
                                    </li>
                                    <li style={{
                                        color: subtitletext, marginTop: '10px'
                                    }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.ServiceRequestFormPoint8bold')}</span> {t('help.ServiceRequestFormPoint8text')}
                                    </li>


                                </ul> 
                            </Box>
                        </Box>
                        <Box className='nav-svg-sec' >
                            <img style={{
                                backgroundColor: 'white',
                                borderRadius: '5px',
                                width: '100%',

                                // maxHeight: '500px',
                                // marginTop: '12px',
                            }} src={ServiceReqeust} alt="Machine Card" />

                        </Box>
                    </Box>


                </Box>


            </div>


        </div>
    )
}

export default Maintainence